import React from 'react';
import { RegionalFreePeriodEligibility } from '../../../api/Api';

import { BrandedAlertModal } from 'components/Modal';

interface RequestResumeActionProps {
    isOpen: boolean
    onConfirm: () => Promise<void>
    onCancel: () => void
    freePeriod?: RegionalFreePeriodEligibility | null
    isRecentlyViewed: boolean
}

const ResumeIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="5" y="3" width="14" height="18" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

const RequestResumeAction = ({
    isOpen,
    onConfirm,
    onCancel,
    freePeriod,
    isRecentlyViewed
}: RequestResumeActionProps) => {
    return (
        <BrandedAlertModal
            isOpen={isOpen}
            onClose={onCancel}
            headerLabel="Candidate Resume"
            headerIcon={<ResumeIcon />}
            illustration={<ResumeIcon />}
            illustrationVariant="info"
            title="View Candidate's Resume?"
            ariaLabel="View candidate's resume"
            actions={[
                { label: 'Cancel', onClick: onCancel, variant: 'secondary' },
                { label: 'View', onClick: onConfirm, variant: 'primary' },
            ]}
        >
            {freePeriod && (
                <p>
                    {freePeriod.customerFacingMessage || `${freePeriod.campaignName}: Viewing this candidate's resume is free and will not use a token.`}
                </p>
            )}
            {isRecentlyViewed && !freePeriod && (
                <p>
                    Great news!
                    <br/>
                    <br/>
                    Normally you would use 1 token to view this resume, but it looks like this candidate has previously applied to you within the last 3 months, so we won’t charge a token to view this resume today.
                </p>
            )}
            {!isRecentlyViewed && !freePeriod && (
                <p>Viewing this resume will use 1 token.</p>
            )}
        </BrandedAlertModal>
    )
}

export default RequestResumeAction;
